export default "__VITE_ASSET__c3165fc7__"